import { render, staticRenderFns } from "./SignupFormAccountants.vue?vue&type=template&id=58c9b4f8&scoped=true&"
import script from "./SignupFormAccountants.vue?vue&type=script&lang=js&"
export * from "./SignupFormAccountants.vue?vue&type=script&lang=js&"
import style0 from "./SignupFormAccountants.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SignupFormAccountants.vue?vue&type=style&index=1&id=58c9b4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c9b4f8",
  null
  
)

export default component.exports